export default "__VITE_ASSET__6a4744a2__"